// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__2KaYb","singleButton":"Navigation_singleButton__2NE8B"};